"use client";

import React from "react";
import Button from "@/components/ui/Button";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { CarouselNextProps } from "../types";
import { useCarouselStore } from "./carousel-provider";

function CarouselNext({
  variant = "outline",
  size = "icon",
  icon = "chevron-right",
  "aria-label": ariaLabel = "Next Slide",
  className,
  ...props
}: CarouselNextProps) {
  const canScrollNext = useCarouselStore(state => state.canScrollNext);
  const scrollNext = useCarouselStore(state => state.scrollNext);

  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  const handleOnClick = React.useCallback(() => {
    scrollNext();
  }, [scrollNext]);

  return (
    <Button.Icon
      variant={variant}
      size={size}
      icon={icon}
      className={cn(className, classes)}
      data-slot="carousel-next"
      disabled={!canScrollNext}
      aria-label={ariaLabel}
      onClick={handleOnClick}
      {...native}
    />
  );
}

export default CarouselNext;
